import { useAuthStore } from "@/stores/auth-store"
import { signInWithApple, signInWithGoogle } from "./use-auth"

/**
 * Shared sign-in surface for both the main `/signin` screen and the
 * post-purchase `/create-account` screen: exposes the current auth state, the
 * Apple/Google triggers, and the shared "sign-in failed" flag that drives the
 * error toast. Each screen decides what to do once authenticated.
 */
export function useSignIn() {
  const status = useAuthStore((s) => s.status)
  const user = useAuthStore((s) => s.user)
  const error = useAuthStore((s) => s.authError)
  const dismissError = useAuthStore((s) => s.clearAuthError)

  const handleApple = async () => {
    try {
      await signInWithApple()
    } catch (err) {
      console.error("Apple sign-in failed:", err)
      useAuthStore.getState().setAuthError()
    }
  }

  const handleGoogle = async () => {
    try {
      await signInWithGoogle()
    } catch (err) {
      console.error("Sign-in failed:", err)
      useAuthStore.getState().setAuthError()
    }
  }

  return { status, user, error, handleApple, handleGoogle, dismissError }
}
